import { useHistory } from "react-router-dom";

import ButtonV2 from "@/v2/Buttons";

export default function HeaderNavLink({ label, to, active = false, bg = "dark", display }) {
  const history = useHistory();

  return (
    <ButtonV2
      p={16}
      letterSpacing="unset"
      textTransform="unset"
      fontSize={16}
      gap={10}
      size={null}
      color={active ? "green" : "white"}
      bg={bg}
      height={[48, 48, 60]}
      borderRadius={0}
      display={display}
      onClick={() => history.push(to)}
      data-component-name={`HeaderNavLink:${label}`}
    >
      {label}
    </ButtonV2>
  );
}
